import { Component, OnInit } from '@angular/core';
import { BaseCommonComponent, BaseDataService, UserService, ModalService, NotificationService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';
// import { NotificationsService } from 'angular2-notifications';
import { TranslateService } from '@ngx-translate/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-rekapitulacija-po-komitentima',
  templateUrl: './rekapitulacija-po-komitentima.component.html'
})
export class RekapitulacijaPoKomitentimaComponent extends BaseCommonComponent implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService,
    protected userService: UserService,
    protected modalService: ModalService,

) {
    super(activatedRoute, userService, baseDataService, translateService, modalService,toastrService);
}

//ako postoji samo jedna organizaciona jedinica onda da na MultiSelectu bute čekirana ta jedna org.jed.
SkupiOrgJed(items)
  {
      if (items.length == 1)
    {
        this.baseFormGroup.patchValue({OrgJedIDS : items[0].ID});
        this.baseFormGroup.get('OrgJedIDS').updateValueAndValidity();
    }
  };


  ngOnInit() {
    super.ngOnInit();

        let dateNow = new Date();
        this.baseFormGroup = new FormGroup({
            OdDatuma: new FormControl(new NgbDate(dateNow.getFullYear(), dateNow.getMonth() + 1, 1), [ Validators.required ]),
            DoDatuma: new FormControl(new NgbDate(dateNow.getFullYear(), dateNow.getMonth() + 1, dateNow.getDate()), [ Validators.required ]),
            Komitent: new FormControl(null, [ Validators.required ]),
            OrgJedIDS: new FormControl(null, [ Validators.required ]),
            Vrsta: new FormControl('1'),
            Donos: new FormControl(false)
        })

        this.addValidatorToFc("Komitent",Validators.required, 'required','REKAPITULACIJAPOKOMITENTIMA.KOMITENT.VALIDATION.REQUIRED');  
        this.addValidatorToFc("OrgJedIDS",Validators.required, 'required','REKAPITULACIJAPOKOMITENTIMA.ORGJED.VALIDATION.REQUIRED');  
  }

}
